import {
  userCentricsConsentGiven,
  userCentricsOnUpdate
} from '../basisCookiebot/userCentrics';

/** Selector for any instance of this _Friendation_ component */
const selector = '[is="basis-cookie-consent-notice"]';

/**
 * Friendation component
 */
export const basisCookieConsentNotice = () => {
  /** Instances of this Friendation component */
  const components: HTMLElement[] = Array.from(
    document.querySelectorAll(selector)
  );

  components.forEach((component) => {
    const updateConsent = () => {
      component.inert = userCentricsConsentGiven('marketing');
    };

    userCentricsOnUpdate(updateConsent);
    updateConsent();
  });
};
